Theme = Theme || {};

Theme.Store = (function ($) {
    var CurrencyUpdateUrlTemplate = '/store/currency/{currencyCode}';
    var $cartView;
    var $orderSummary;
    var $formContainer;
    const regexPatterns = {
        allowedCharacters: new RegExp($('.js-address-allowed-characters').val() || '.*'), 
        zipCodeCharacters: new RegExp($('.js-address-zip-code-characters').val() || '.*')
    };

    return {
        init: _init
    };

    function _init() {
        $formContainer = $('.register-content-wrap');
        $cartView = $('.js-cart-view');
        $orderSummary = $('.js-order-summary');
        if (!$cartView.length && !$orderSummary.length && !$formContainer.length) {
            return;
        }

        _wireCurrencySelector();
        _wireVatCountrySelector();
        _wireVatNumberValidateButton();        
        $('.js-cart-proceed').on('click', onProceedToCheckout);
        $('#checkSaveMessage').on('click', onSameAddress);
        $('#checkSaveMessages').on('click', onDifferentAddress);
        $('.js-cart-saveaddress').on('click', updateAddress);
        $('.js-limit').on('input', function () { checkMaxLength(this); });
        if ($('.js-validate-address-characters').val()) {
            $('.js-validate-characters').on('input', function () { validateCharacters(this); });
        }
        $formContainer.on('change', '#BillingCountryList', function () {
            _checkRequiredFieldsForBillingAddress();
            _loadBillingCountryStates();
        });
        $formContainer.on('change', '#ShippingCountryList', function () {
            _checkRequiredFieldsForShippingAddress();
            _loadShippingCountryStates();
        });

        _wireQuantityEditButtons();
        _wirePromoCodeButtons();
        _initRequiredAddressFields();
    }

    function checkMaxLength(input) {
        var messageElement = document.getElementById(input.id + 'Message');
        if (input.value.length >= input.maxLength) {
            messageElement.classList.remove('hide');
        } else {
            messageElement.classList.add('hide');
        }
    }

    function validateCharacters(input) {
        var regexKey = $(input).data('validation-pattern');
        var regex = regexPatterns[regexKey];

        if (!regex) {
            return;
        }

        var $messageElement = $('#' + $(input).attr('id') + 'CharacterValidationMessage');

        if (!regex.test($(input).val())) {
            $messageElement.removeClass('hide');
        } else {
            $messageElement.addClass('hide');
        }
    }

    function _initRequiredAddressFields() {
        var $shippingStateList = $('#ShippingStateList');
        var $shippingStateListOptions = $('#ShippingStateList option');
        var $billingStateList = $('#BillingStateList');   
        var $billingStateListOptions = $('#BillingStateList option');   
        var $shippingStateLabel = $("label[for='ShippingStateList']");
        var $billingStateLabel = $("label[for='BillingStateList']");

        if ($shippingStateList.length && !$shippingStateListOptions.length) {
            $shippingStateLabel.hide();
            $shippingStateList.hide();
        }
        else if ($shippingStateList.length) {
            $shippingStateLabel.show();
            $shippingStateList.show();
        }

        if ($billingStateList.length && !$billingStateListOptions.length) {
            $billingStateLabel.hide();
            $billingStateList.hide();
        }
        else if ($billingStateList.length) {
            $billingStateLabel.show();
            $billingStateList.show();
        }

        if ($('#BillingCountryList').length) {
            _checkRequiredFieldsForBillingAddress();
        }
        if ($('#ShippingCountryList').length) {
            _checkRequiredFieldsForShippingAddress();
        }
    }

    function _checkRequiredFieldsForBillingAddress() {
        var billingCountryCode = $('.register-content-wrap').find('#BillingCountryList').find(':selected').data('countrycode');
 
       if (billingCountryCode == 'US') {
            $('.js-billingzipcoderequired').removeClass('hide');
            $('.js-billingstaterequired').removeClass('hide');
           return;
        }

       if (billingCountryCode == 'GB') {
           $('.js-billingzipcoderequired').removeClass('hide');
           return;
        }

        $('.js-billingzipcoderequired').addClass('hide');
        $('.js-billingstaterequired').addClass('hide');
    }

    function _checkRequiredFieldsForShippingAddress() {
        var shippingCountryCode = $('.register-content-wrap').find('#ShippingCountryList').find(':selected').data('countrycode');

        if (shippingCountryCode == 'US') {
            $('.js-shippingzipcoderequired').removeClass('hide');
            $('.js-shippingstaterequired').removeClass('hide');
            return;
        }

        if (shippingCountryCode == 'GB') {
            $('.js-shippingzipcoderequired').removeClass('hide');
            return;
        }
       
        $('.js-shippingzipcoderequired').addClass('hide');
        $('.js-shippingstaterequired').addClass('hide');
        
    }

    function _wirePromoCodeButtons() {
        $('.js-apply-promo-code').on('click', function (e) {
            var isRemoveButton = $(e.currentTarget).hasClass('js-remove-code');
            var discountCodeLogic = isRemoveButton ? 'RemoveDiscountCode' : 'AddDiscountCode';
            var url = `/store/${discountCodeLogic}/Ajax`;
            var promoCode = $('.js-promo-code').val();            
            if (promoCode.length) {
                var requestParams = { discountCode: promoCode };
                SCM.Ajax.post(url, requestParams)
                    .expectJson()                    
                    .then(function (result) {
                        if (result.Messages !== undefined && result.Messages.length) {                            
                            SCM.Announce.alert($('.promo-wrap').find('.js-error-message'), result.Messages[0]);
                        } else {                            
                            // update quantity and reload
                            if ($('.js-quantityEditable').length) {
                                updateQuantityInCartAndProceed(window.location);
                            } else {
                                window.location.reload();
                            }                            
                        }
                    })
                    .catch(function (reason) {
                        console.error(`Failed to update discount code: ${reason}`);
                    }); 
            }
        });
    }

    function onProceedToCheckout() {
        var $link = $('.js-cart-proceed');
        var updateQuantityInCart = $link.hasClass('js-quantityEditable');
        var destination = $link.data('destination');
        if ($('#checkProceedMessage').is(':visible')) {

            var checkboxChecked = $('#checkProceedMessage').is(':checked');
            if (checkboxChecked) {
                updateQuantityInCartAndProceed(destination, updateQuantityInCart);
            } else {
                const $termsError = $('.js-cart-terms-error');
                SCM.Announce.alert($termsError, $termsError.data('message'));
            }
        } else {
            updateQuantityInCartAndProceed(destination, updateQuantityInCart);
        }
    }    

    function updateQuantityInCartAndProceed(destinationUrl) {
        var cartItemQuantityLookup = {};
        $('.input-number').each(function () {
            var quantity = $(this).val();
            var initValue = $(this).data('initvalue');
            if (quantity != initValue) {
                var itemId = $(this).data('itemid');
                cartItemQuantityLookup[itemId] = quantity;
            }
        });
        if (Object.keys(cartItemQuantityLookup).length) {
            SCM.Ajax.post('/store/UpdateQuantityInCart/Ajax', { cartItemQuantityLookup: cartItemQuantityLookup })
                .expectActionResultModel()
                .ensureSuccess()
                .then(function () {
                    window.location = destinationUrl;
                })
                .catch(function (reason) {
                    console.error(`Failed to upate quanitity in cart: ${reason}`);
                });

        } else {
            if (SCM.GoogleTagManagerDataLayerEvents) {
                var cartInfoElement = $('.js-cart-view');
                var cartItemElements = $('.cartview-item');
                if (cartInfoElement.length && cartItemElements.length) {
                    var cartInfo = {
                        Currency: cartInfoElement.data('currency'),
                        TotalPrice: cartInfoElement.data('totalPrice'),
                        Tax: cartInfoElement.data('tax'),
                        Items: [],
                    };
                    $(cartItemElements).each(function () {
                        var cartItem = {
                            ProductName: this.dataset.productName,
                            ProductDescription: this.dataset.productDescription,
                            Price: this.dataset.price,
                            ProductId: this.dataset.productid,
                            Terms: this.dataset.terms
                        };
                        cartInfo.Items.push(cartItem);
                    });
                    SCM.GoogleTagManagerDataLayerEvents.logECommerceProceedEvent(destinationUrl, cartInfo);
                }
            }
            window.location = destinationUrl;
        }
    }

    function onSameAddress() {
        if ($('#checkSaveMessages').is(':checked')) {
            $('.shippingAddress').hide();
        }
        $('.js-cart-saveaddress').removeClass('disabled');
        $('#checkSaveMessages').prop('checked', false); 
    }

    function onDifferentAddress() {
        _loadShippingCountryStates();
        $('#checkSaveMessage').prop('checked', false);
        $('.shippingAddress').show();
        $('.js-cart-saveaddress').removeClass('disabled');
    }

    function updateAddress() {
        var $addressDiv = $('.register-content-wrap');
        const $errorMessage = $addressDiv.find('.error-message');
        let sameAddress = false;

        if ($('#checkSaveMessage').is(':checked')) {
            onSameAddress();
            sameAddress = true;
        }

        $errorMessage.removeAttr('role').empty();
        var billingaddress = $addressDiv.find('#BillingAddress').val();
        var billingaddress2 = $addressDiv.find('#BillingAddress2').val();
        var billingaddress3 = $addressDiv.find('#BillingAddress3').val();
        var billingcity = $addressDiv.find('#BillingCity').val();
        var billingstateList = $addressDiv.find('#BillingStateList').val() || '';
        var billingcountryList = $addressDiv.find('#BillingCountryList').val();
        var billingzipCode = $addressDiv.find('#BillingZipCode').val();
        var billingCountryCode = $addressDiv.find('#BillingCountryList').find(':selected').attr('data-countrycode');

        var shippingaddress = sameAddress ? billingaddress : $addressDiv.find('#ShippingAddress').val();
        var shippingaddressLine2 = sameAddress ? billingaddress2 : $addressDiv.find('#ShippingAddress2').val();
        var shippingaddressLine3 = sameAddress ? billingaddress3 : $addressDiv.find('#ShippingAddress3').val();
        var shippingcity = sameAddress ? billingcity : $addressDiv.find('#ShippingCity').val();
        var shippingstateList = sameAddress ? billingstateList : $addressDiv.find('#ShippingStateList').val() || '';
        var shippingcountryList = sameAddress ? billingcountryList : $addressDiv.find('#ShippingCountryList').val();
        var shippingzipCode = sameAddress ? billingzipCode : $addressDiv.find('#Shippingzip').val();
        var shippingCountryCode = sameAddress ? billingCountryCode : $addressDiv.find('#ShippingCountryList').find(':selected').attr('data-countrycode');
        var phoneNumber = $addressDiv.find('#PhoneNumber').val() || '';

        var firstname = $addressDiv.find('#FirstName').val();
        var lastname = $addressDiv.find('#LastName').val();
        var email = $addressDiv.find('#Email').val();
        var affiliation = $addressDiv.find('#Affiliation').val();
        var marketingEmails = $addressDiv.find('#MarketingOptIn').is(':checked');

        var userInfo = {
            'ShippingAddress': shippingaddress,
            'ShippingAddress2': shippingaddressLine2,
            'ShippingAddress3': shippingaddressLine3,
            'ShippingCity': shippingcity,
            'ShippingStateId': shippingstateList,
            'ShippingCountryId': shippingcountryList,
            'ShippingZipCode': shippingzipCode,
            'ShippingCountryCode': shippingCountryCode,
            'BillingAddress': billingaddress,
            'BillingAddress2': billingaddress2,
            'BillingAddress3': billingaddress3,
            'BillingCity': billingcity,
            'BillingStateId': billingstateList,
            'BillingCountryId': billingcountryList,
            'BillingZipCode': billingzipCode,
            'BillingCountryCode': billingCountryCode,
            'PhoneNumber': phoneNumber,
            'FirstName': firstname,
            'LastName': lastname,
            'Email': email,
            'Affiliation': affiliation,
            'ReceivesMarketingAlerts': marketingEmails
        };

        SCM.Ajax.post('/Store/CartAddOrUpdateUserProfileAddressModel/updateAddress', userInfo)  
            .expectActionResultModel()
            .ensureSuccess()
            .then(function () {               
                $addressDiv.find('.js-cart-proceed').toggleClass('hide');
                $('.js-cart-saveaddress').removeClass('proceed-btn').addClass('btn-inv');
            })
            .catch(function (reason) {
                var result = reason.actionResultModel;
                if (result.Messages !== undefined && result.Messages.length) {
                    var listItems = '';
                    $.each(result.Messages,
                        function (i, v) {
                            listItems += `<li>${v}</li>`;
                        });
                    $errorMessage.removeClass('hide');
                    SCM.Announce.alert($errorMessage, `<ul>${listItems}</ul>`);
                    var proceedCartBtn = $addressDiv.find('.js-cart-proceed');
                    if (proceedCartBtn && !proceedCartBtn.hasClass('hide')) {
                        proceedCartBtn.addClass('hide');
                    }
                }
            });
    }

    function _loadBillingCountryStates() {
        var $addressDiv = $('.register-content-wrap');
        var billingCountryId = $addressDiv.find('#BillingCountryList').val();
        var billingStateList = $addressDiv.find('#BillingStateList');   
        var billingStateLabel = $("label[for='BillingStateList']");

        billingStateList.empty().prop('disabled', true);
        if (billingCountryId !== undefined && billingCountryId.length) {
            var countryData = { 'countryId': billingCountryId };
            SCM.Ajax.post('/Store/GetCountryStates/GetStates', countryData)    
                .expectJson()               
                .then(function (result) { 
                        billingStateList.append($(`<option value="">--Please Select--</option>`));

                        $.each(result, function (i, v) {
                            billingStateList.append($(`<option value="${v.StateId}">${v.StateName}</option>`));
                        });
                        if (result.length === 0) {
                            billingStateLabel.hide();
                            billingStateList.hide();
                        }
                        else {
                            billingStateLabel.show();
                            billingStateList.show();
                        }

                        billingStateList.prop('disabled', false);                   
                })
                .catch(console.error);
        }
    }
    function _loadShippingCountryStates(countryID) {
        var shippingCountryData;
        var $addressDiv = $('.register-content-wrap');
        var shippingCountryId = $addressDiv.find('#ShippingCountryList').val();
        var shippingStateList = $addressDiv.find('#ShippingStateList');
        var shippingStateLabel = $("label[for='ShippingStateList']");
        shippingStateList.empty().prop('disable', true);
        if (countryID !== undefined && countryID > 0) {
            shippingCountryData = { 'countryId': countryID };
            
        } else if(shippingCountryId !== undefined && shippingCountryId.length) {
            shippingCountryData = { 'countryId': shippingCountryId };
        }
        SCM.Ajax.post('/Store/GetCountryStates/GetStates', shippingCountryData)   
            .expectJson()
            .then(function (result) {
                shippingStateList.append($(`<option value="">--Please Select--</option>`));

                $.each(result, function (i, v) {
                    shippingStateList.append($(`<option value="${v.StateId}">${v.StateName}</option>`));
                });
                if (result.length === 0) {
                    shippingStateLabel.hide();
                    shippingStateList.hide();
                }
                else {
                    shippingStateLabel.show();
                    shippingStateList.show();
                }
                shippingStateList.prop('disabled', false);
            })
            .catch(console.error);
        }
    
    function _wireCurrencySelector() {
        $cartView.find('.js-currency-selector').on('change', function (e) {
            var currencyCode = $(e.currentTarget).val();
            
            if ($('.js-item-quantity').length) {
                updateQuantityInCartAndProceed(CurrencyUpdateUrlTemplate.replace('{currencyCode}', currencyCode));
            } else if (currencyCode) {
                window.location.href = CurrencyUpdateUrlTemplate.replace('{currencyCode}', currencyCode);
            }
        });
    }

    function _wireVatCountrySelector() {
        $orderSummary.find('.js-vat-country-select').on('change', function (e) {
            var countryCode = $(e.currentTarget).val();
            Theme.Store.DataService.updateVatCountry(countryCode)
                .then(function (data) {
                    var $vatNumberWrap = $orderSummary.find('.js-vat-number-wrap');
                    if (data && data.ShowVatNumber) {
                        $vatNumberWrap.removeClass('hidden');
                    } else {
                        $vatNumberWrap.addClass('hidden');
                    }
                })
                .catch(function (reason) {
                    console.error('Failed to update VAT country: ' + reason);
                    $orderSummary.find('.js-vat-message')
                        .html('Failed to update VAT Country')
                        .removeClass('success')
                        .addClass('error');
                });
        });
    }

    function _wireVatNumberValidateButton() {
        $orderSummary.find('.js-apply-vat-number').on('click', function () {
            var vatNumber = $orderSummary.find('.js-vat-number').val().trim();
            if (!vatNumber) {
                return;
            }
            var $vatMessage = $orderSummary.find('.js-vat-message');
            var $vatAmount = $('.js-tax-estimate');

            Theme.Store.DataService.updateVatNumber(vatNumber)
                .then(function () {
                    $vatMessage.html('VAT Number validated')
                        .removeClass('error')
                        .addClass('success');
                    if ($vatAmount.length) {
                        $vatAmount.html('0.00');
                    }
                })
                .catch(function (reason) {
                    console.error(`Failed to update VAT number: ${reason}`);
                    $orderSummary.find('.js-vat-message')
                        .html('Failed to validate VAT Number')
                        .removeClass('success')
                        .addClass('error');
                });
        });
    }

    function _wireQuantityEditButtons() {
        $('.cartview-item').each(function () {                        
            var itemContainer = $(this);
            $(itemContainer).find('.js-quantity-increase').on('click', function () {
                var quantityEle = $(itemContainer).find('.input-number');
                var counter = $(quantityEle).val();                
                var maxValue = $(quantityEle).data('maxvalue');
                if (counter < maxValue) {
                    counter++;
                    setCartItemQuantity(itemContainer, counter);               
                }                
            });
            $(itemContainer).find('.js-quantity-decrease').on('click', function () {
                var quantityEle = $(itemContainer).find('.input-number');
                var counter = $(quantityEle).val();
                var minValue = $(quantityEle).data('minvalue');
                if (counter > minValue) {                                       
                    counter--;
                    setCartItemQuantity(itemContainer, counter); 
                }
            });
        });

        $('.js-item-quantity').on('change', function () {
            var quantity = $(this).val();
            var itemContainer = $(this).closest('.cartview-item');

            var minValue = $(this).data('minvalue');
            var maxValue = $(this).data('maxvalue');
            if (quantity < minValue) {
                $(this).val(minValue);
                setCartItemQuantity(itemContainer, minValue);
                return;
            }
            if (quantity > maxValue) {
                $(this).val(maxValue);
                setCartItemQuantity(itemContainer, maxValue);
                return;
            }
            setCartItemQuantity(itemContainer, quantity);
        });      
    }    

   

    function setCartItemQuantity(itemContainer, quantityValue) {
        $(itemContainer).find('.input-number').val(quantityValue);
        _announceQuantity(itemContainer, quantityValue);
        var price = $(itemContainer).find('.cartview-item-value-price-per').text();
        var itemDiscountAmount = $(itemContainer).find('.cartview-item-discount-amount-per').attr('data-originalDiscount');
        var shippingItemAmount = $(itemContainer).find('.cartview-item-shipping-amount-per').text();
        var totalItemPrice = quantityValue * price;
        $(itemContainer).find('.cartview-item-price-total').text(totalItemPrice.toFixed(2));

        if (itemDiscountAmount > 0.00) {
            var totalDiscountAmountForCurrentLineItem = quantityValue * itemDiscountAmount;
            $(itemContainer).find('.cartview-item-discount-amount-per').text(totalDiscountAmountForCurrentLineItem.toFixed(2));
            setTotalDiscountAmount();
        }    
        if (shippingItemAmount > 0.00) {
            var shippingTotal = shippingItemAmount * quantityValue;
            $(itemContainer).find('.cartview-item-shipping-amount-total').text(shippingTotal.toFixed(2));
        }
        updateSubTotal();        
        updateShippingTotal();
    }

    

    function setTotalDiscountAmount() {
        var discountCartViewItem = $('.cartview-discount');
        if (discountCartViewItem.length) {            
            var totalDiscountAmount = 0;
            $('.cartview-item-discount-amount-per').each(function () {
                var currentItemdiscount = $(this).text();
                totalDiscountAmount += parseFloat(currentItemdiscount);
            });
            $(discountCartViewItem).find('.cartview-item-price-total').text('-'+totalDiscountAmount.toFixed(2));
        }       
    }    

    function updateSubTotal() {
        var subTotalElement = $('.js-subtotal-amount');       
        var newTotal = 0.00;
        $('.cartview-item').each(function () {            
            var itemValue = $(this).find('.cartview-item-price-total').text();
            newTotal = parseFloat(newTotal) + parseFloat(itemValue);
        });
        subTotalElement.text(newTotal.toFixed(2));
    }  

    function updateShippingTotal() {        
        var $shippingTotalElement = $('.js-shipping-amount');
        const total = calculateShippingTotal();
        const $maxShippingLimitDiv = $('.subtotal-maxshippinglimit');

        Theme.Store.DataService.getMaxShippingAmount()
            .then(function (shippingAmount) {
                if (total > shippingAmount) {
                    $shippingTotalElement.text(shippingAmount);
                    $maxShippingLimitDiv.removeClass('hide').addClass('show');
                } else {
                    $shippingTotalElement.text(total.toFixed(2));
                    $maxShippingLimitDiv.removeClass('show').addClass('hide');
                }
            })
            .catch(function (error) {                             
                $shippingTotalElement.text(newTotal.toFixed(2));
                $maxShippingLimitDiv.removeClass('show').addClass('hide');
            });
    }
    function calculateShippingTotal() {
        var newTotal = 0.00;
        $('.cartview-item').each(function () {
            var itemValue = $(this).find('.cartview-item-shipping-amount-total').text();
            newTotal = parseFloat(newTotal) + parseFloat(itemValue);
        });
        return newTotal;

    }

    function _announceQuantity(itemContainer, quantityValue) {
        const $status = itemContainer.find('.js-quantity-status');
        if (!$status.length) {
            return;
        }
        const itemName = $.trim(itemContainer.find('.item-name').first().text());
        $status.text(itemName ? itemName + ', quantity ' + quantityValue : 'Quantity ' + quantityValue);
    }


})(jQuery);


Theme.Store.DataService = (function ($) {
    var UpdateVatCountryUrl = '/store/UpdateCartVatCountry/Ajax';
    var UpdateVatNameUrl = '/store/UpdateVatNumber/Ajax';    
    const GetMaxShippingAmountUrl = '/store/GetShippingAmount/Ajax';
    

    return {
        updateVatCountry: _updateVatCountry,
        updateVatNumber: _updateVatNumber,
        getMaxShippingAmount: _getMaxShippingAmount        
    };

    function _updateVatCountry(countryCode) {
        return $.post(UpdateVatCountryUrl, { countryCode: countryCode })
            .promise()
            .then(function (result) {
                return _checkResultForData(result);
            });
    }    

    function _updateVatNumber(vatNumber) {
        return $.post(UpdateVatNameUrl, { vatNumber: vatNumber })
            .promise()
            .then(function (result) {
                return _checkResultForSuccess(result);
            });
    }    

    function _getMaxShippingAmount() {
        return $.post(GetMaxShippingAmountUrl)
            .promise()
            .then(function (result) {
                return _checkResultForData(result);
            });
    }
    function _checkResultForSuccess(result) {
        if (!result || !result.Success) {
            var errorMessage = result && result.Messages && result.Messages.length && result.Messages[0].length
                ? result.Messages[0]
                : 'An unknown error occurred';
            return Promise.reject(errorMessage);
        }

        return true;
    }

    function _checkResultForData(result) {
        if (!result || !result.Success) {
            var errorMessage = result && result.Messages && result.Messages.length && result.Messages[0].length
                ? result.Messages[0]
                : 'An unknown error occurred';
            return Promise.reject(errorMessage);
        }

        return result.Data;
    }

})(jQuery);
